import { render, staticRenderFns } from "./product-upload.vue?vue&type=template&id=3345287b&scoped=true"
import script from "./product-upload.vue?vue&type=script&lang=js"
export * from "./product-upload.vue?vue&type=script&lang=js"
import style0 from "./product-upload.vue?vue&type=style&index=0&id=3345287b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345287b",
  null
  
)

export default component.exports